import styled from 'styled-components'
import { Link } from 'gatsby'

import { DEVICE } from '../../../util/constants'
import { BodyCopy } from '../../ContentBlocks/styles/BodyContentBlock.styles'

export const HeroContainer = styled.div`
  display: grid;
  grid-template-columns: 32px 10fr 32px;

  @media ${DEVICE.tabletL} {
    grid-template-columns: 1fr 10fr 1fr;
    max-width: 1317px;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-template-columns: 1fr;
      max-width: none;
      width: 100%;
    }
  }
`

export const BackButtonContainer = styled(Link)`
  grid-column: 2 / 3;
  grid-row: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration-line: none;
  margin-top: 41px;
  margin-bottom: 25px;

  svg {
    margin-right: 20px;
  }

  span {
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.357;
    text-transform: uppercase;
    color: var(--content-background-dark-blue);
  }

  @media ${DEVICE.tabletL} {
    span {
      font-size: 1.4rem;
    }
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: 1 / -1;
    }
  }
`

export const LogoTopicDateRegion = styled.div`
  grid-column: 2 / 3;
  grid-row: 2;
  display: flex;
  flex-direction: column;
  justify-items: center;

  @media ${DEVICE.tabletL} {
    flex-direction: row;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: 1 / -1;
    }
  }
`

export const TopicAndDateBox = styled.div`
  display: flex;
  flex-direction: column;

  @media ${DEVICE.tabletL} {
    padding-left: 21px;
  }
`

export const Topic = styled.h3`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 2;
  text-transform: uppercase;
  color: var(--highlight-blue);

  span {
    color: var(--content-background-dark-blue);
  }
`

export const MediaItemDate = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1.6rem;
  line-height: 1.8;
  letter-spacing: 0.02em;
  color: var(--highlight-blue);
  color: var(--content-background-dark-blue);
`

export const TextRegion = styled.div`
  grid-column: 2 / 3;
  grid-row: 3;

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: 1 / -1;
    }
  }
`

export const MediaItemTitle = styled.div`
  h1 {
    padding-top: 24px;
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 2.8rem;
    line-height: 1.35;
    color: var(--highlight-blue);

    @media ${DEVICE.tabletL} {
      font-size: 4rem;
    }
  }
`

export const MediaItemDescription = styled(BodyCopy)`
  padding-top: 14px;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1.8rem;
  line-height: 1.6;
  color: var(--content-background-dark-blue);
  grid-column: 2 / 3;

  p {
    margin-bottom: 2rem;
  }

  @media ${DEVICE.tabletL} {
    font-size: 2rem;
  }
`

export const HeroImage = styled.picture`
  grid-column: 2 / 3;
  grid-row: 5;
  padding-top: 41px;
`

export const CmeCtaContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  align-content: stretch;
  padding: 14px 0;
  text-decoration-line: none;
  margin-top: 0;
  /* stylelint-disable value-keyword-case */
  ${({ $additionalStyles }) => $additionalStyles}
`
export const CmeCtaCredits = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.3rem;
  line-height: 1.3;
  font-weight: bold;
  letter-spacing: 0.02em;
  color: #fff;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: var(--content-background-dark-blue);
  width: 74px;
  flex-shrink: 0;
`
export const CmeCtaCreditsValue = styled.div`
  font-size: 2.1rem;
  line-height: 1.2;
  font-weight: 400;
  letter-spacing: 0.02em;
  margin-top: -2px;
  position: relative;
`

export const CmeCtaTextWrapper = styled.div`
  flex: auto;
  display: flex;
  justify-content: flex-end;
  font-size: 1.4rem;
  line-height: 1.4;
  font-weight: bold;
  letter-spacing: 0.02em;
  padding: 15px 32px 14px 0;
  color: #fff;
  background-color: var(--highlight-blue);

  @media ${DEVICE.tabletL} {
    font-size: 1.6rem;
  }
`

export const CmeCtaTextLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #fff;
  text-decoration: none;
  text-align: right;
  margin-left: 15px;

  svg {
    flex-shrink: 0;
    margin-left: 14px;
  }

  svg .rollover {
    display: none;
  }

  :hover {
    svg .rollover {
      display: inherit;
    }

    svg .normal {
      display: none;
    }
  }
`

export const CmeCtaPodcastStyles = `
  margin-top: -15px;
  padding-top: 0;
  padding-bottom: 30px;
`

export const CmeCtaVideoStyles = `
  margin-top: -60px;
  padding-top: 0;
  padding-bottom: 50px;
`
